// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RecurrenceAvailability {\n  width: 100%;\n  margin-top: 10px;\n}\n", "",{"version":3,"sources":["webpack://./src/views/Search/SearchResults/SearchResultCard/RecurrenceAvailability/_style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".RecurrenceAvailability {\n  width: 100%;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
